'use client';

import { c as _c } from "react/compiler-runtime";
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { IS_DEV } from '@/constants';
import { MswProvider } from '@/mocks/MswProvider';
import { GlobalController } from '@/modules';
import { DeviceInfoStoreProvider, useMountDeviceInfoStore } from '@/stores/DeviceStore';
import { cookies } from '@/utils/cookies';
import { ChannelTalk } from '../ChannelTalk';
import { AccountIntegrationController } from './_components/AccountIntegrationController';
import { AuthProvider } from './_components/AuthProvider';
import { BenefitEntryConsentController } from './_components/BenefitEntryConsentController';
import { GuestProvider } from './_components/GuestProvider';
import { HistoryObserver } from './_components/HistoryObserver';
import { JoinController } from './_components/JoinController';
import { PageViewEventLogger } from './_components/PageViewEventLogger';
import { useGlobalEventListener } from './_hooks/useGlobalEventListener';
import { useGtmEventClickListener } from './_hooks/useGtmEventClickListener';
import { useLoginGtmEventListener } from './_hooks/useLoginGtmEventListener';
import { getQueryClient } from './getQueryClient';
interface GlobalProviderProps {
  children: React.ReactNode;
}
const GlobalProviderContents = t0 => {
  const $ = _c(14);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  useMountDeviceInfoStore();
  useGlobalEventListener();
  useGtmEventClickListener();
  useLoginGtmEventListener();
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      path: "/"
    };
    t3 = <PageViewEventLogger />;
    t4 = <HistoryObserver />;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <BenefitEntryConsentController />;
    t6 = <GlobalController />;
    t7 = <AccountIntegrationController />;
    t8 = <JoinController />;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t5 = $[4];
    t6 = $[5];
    t7 = $[6];
    t8 = $[7];
  }
  let t9;
  if ($[8] !== children) {
    t9 = <AuthProvider><GuestProvider>{t5}{t6}{t7}{t8}{children}</GuestProvider></AuthProvider>;
    $[8] = children;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = IS_DEV ? <ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} /> : null;
    t11 = <ChannelTalk />;
    $[10] = t10;
    $[11] = t11;
  } else {
    t10 = $[10];
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t9) {
    t12 = <MswProvider><QueryClientProvider client={queryClient}><CookiesProvider cookies={cookies} defaultSetOptions={t2}>{t3}{t4}{t9}{t10}{t11}</CookiesProvider></QueryClientProvider></MswProvider>;
    $[12] = t9;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  return t12;
};
export const GlobalProvider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <DeviceInfoStoreProvider><GlobalProviderContents>{children}</GlobalProviderContents></DeviceInfoStoreProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};